import { useMemo } from "react";
import { useSelector } from "react-redux";

import AddJobRole from "../Profile/ProfileCriteria/JobRoles/AddJobRole";
import JobRoleCredentials from "../Profile/ProfileCriteria/JobRoles/JobRoleCredentials";
import MapJobRoleToSpecialties from "../Profile/ProfileCriteria/JobRoles/MapJobRoleToSpecialties";
import AddSpecialty from "../Profile/ProfileCriteria/Specialties/AddSpecialty";
import MapSpecialtyToJobRole from "../Profile/ProfileCriteria/Specialties/MapSpecialtyToJobRole";
import AddOnBoardingDocuments from "../Profile/ProfileCriteria/OnBoardingDocuments/AddOnBoardingDocuments";

import AddNewDoc from "../Profile/ProfileCriteria/HealthDocuments/AddNewDoc";
import AssignJobRole from "../Profile/ProfileCriteria/HealthDocuments/AssignJobRoles";
import AddRequiredFields from "../Profile/ProfileCriteria/HealthDocuments/AddRequiredFields";

import AddOnBoardingDocuments2 from "../Profile/ProfileCriteria/OnBoardingDocuments/AddOnBoardingDocuments2";


import ChecklistData from "../Profile/ProfileCriteria/Specialties/AddChecklist";
import CreateChecklist from "../Profile/ProfileCriteria/Specialties/CreateChecklist";
import CreateAssessment from "../Profile/ProfileCriteria/Specialties/CreateAssessment";
import AssignCertificate from "../Profile/ProfileCriteria/Specialties/AssignCertificate";
import SkillSet from "../Profile/ProfileCriteria/Specialties/SkillSet";
import QuestionForm from "../Profile/ProfileCriteria/Specialties/Assessment";
import AddCertification from "../Profile/ProfileCriteria/Certifications/AddCertification";
import AssignSpeciality from "../Profile/ProfileCriteria/Certifications/AssignSpeciality";
import RequiredFields from "../Profile/ProfileCriteria/Certifications/RequiredFields";
import AddTraining from "../Profile/ProfileCriteria/Learnings/AddTraining";
import LessonList from "../Profile/ProfileCriteria/Learnings/TrainingEditor"

export const MultiPartScreens = ({ screen }) => {
    const { step } = useSelector((state) => state.multiStep);
    const renderStepComponent = useMemo(() => {
        switch (screen) {
            case "JobRole":
                switch (step) {
                    case 0: return <AddJobRole />;
                    case 1: return <JobRoleCredentials />;
                    case 2: return <MapJobRoleToSpecialties />;
                    default: return null;
                }
            case "Specialties":
                switch (step) {
                    case 0: return <AddSpecialty />;
                    case 1: return <MapSpecialtyToJobRole />;
                    case 2: return <ChecklistData />
                    case 3: return <CreateChecklist />
                    case 4: return <SkillSet />
                    case 5: return <CreateAssessment />
                    case 6: return <QuestionForm />
                    case 7: return <AssignCertificate />
                    default: return null;
                }
            case "OnBoardingDocuments":
                switch (step) {
                    case 0: return <AddOnBoardingDocuments />;
                    case 1: return <AddOnBoardingDocuments2 />;
                    default: return null;
                }
            case "HealthDocuments":
                switch (step) {
                    case 0: return <AddNewDoc />;
                    case 1: return <AssignJobRole />;
                    case 2: return <AddRequiredFields />;
                    default: return null;
                }

            case "LearningDocuments":
                switch (step) {
                    case 0: return <AddTraining />;
                    case 1: return <LessonList />;
                    // case 1: return <AssignJobRole />;
                    // case 2: return <AddRequiredFields />;
                    default: return null;
                }
            case "Certifications":
                switch (step) {
                    case 0: return <AddCertification />;
                    case 1: return <AssignSpeciality />;
                    case 2: return <RequiredFields />;
                    default: return null;
                }
            default:
                return null;
        }
    }, [screen, step]);

    return <>

        {renderStepComponent}

    </>;
};
